import { R as React } from './injectIntl-6b03af4d.js';
import { u as useIntl } from './useIntl-dfb28031.js';
import { I as IconButton } from './IconButton-25fc57e6.js';

/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const ApIconButtonReact = React.forwardRef((props, ref) => {
    const { color = 'primary', size = 'medium', disabled, label, expanded } = props, rest = __rest(props, ["color", "size", "disabled", "label", "expanded"]);
    const { formatMessage: translate } = useIntl();
    return (React.createElement(IconButton, Object.assign({ ref: ref, color: color, size: size, disabled: disabled, "aria-expanded": expanded, "aria-label": label !== null && label !== void 0 ? label : translate({ id: 'default-icon-button' }) }, rest), props.children));
});

export { ApIconButtonReact as A };

//# sourceMappingURL=ap-icon-button.react-90212225.js.map